import React from "react";

const Footer = () => {
    return (
        <div className="mt-5">
            <footer className="footer text-white">
                <div className="container">
                    <footer className="py-1">
                        <div className="d-flex justify-content-between pt-1 mt-4 border-top">
                            <p className="mb-0">
                                <a
                                    href="https://github.com/ortiz140"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-white text-decoration-none"
                                >
                                    GitHub: @ortiz140
                                </a>
                            </p>
                            <p>
                                ortiz140@purdue.edu
                            </p>
                        </div>
                    </footer>
                </div>
            </footer>
        </div>
    );
}

export default Footer;
